import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_BnxbEHlEMgOG: {
	id: 'prd_BnxbE2DEV2HlEMgOG'
	ident: 'prd_BnxbEHlEMgOG'
	sku: 'simple_premium_3m_1_1m_29_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 3
			iteration_count: 1
			price_id: 'prc_ehGaO2DEV2N0Jq9ji'
			amount: 1
			amount_usd: 1
			cancellation_fee: null
			currency: 'USD'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: null
			price_id: 'prc_8vvUf2DEV22OaFvst'
			amount: 29.99
			amount_usd: 29.99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_BnxbEHlEMgOG, SubscriptionProduct>
const prd_BnxbEHlEMgOG = { ident: 'prd_BnxbEHlEMgOG' } as typeof _prd_BnxbEHlEMgOG

export default prd_BnxbEHlEMgOG
